import { useTranslation } from 'react-i18next'
import { toast } from '@node-space/ui-components'
import { useWithdrawFromPortfolioMutation } from 'hooks/mutations/Rewards/useWithdrawFromPortfolioMutation'
import { BaseErrorResponse } from 'types/beneficiaries'
import { RewardsWithdrawFormData } from '../../types'
import { useRewardsTracking } from '../useRewardsTracking'

export const useRewardsWithdraw = ({
  isRemoveAllocation = false,
  onSuccess,
  onError,
}: {
  isRemoveAllocation: boolean
  onSuccess: () => void
  onError: (error: BaseErrorResponse) => void
}) => {
  const { t } = useTranslation()
  const { trackSuccess, trackError } = useRewardsTracking()

  const { mutate: withdrawFromPortfolio, isPending: isRewardsWithdrawPending } =
    useWithdrawFromPortfolioMutation()

  const onRewardsWithdraw = (data: RewardsWithdrawFormData) => {
    return withdrawFromPortfolio(
      {
        beneficiary: {
          walletId: data.withdrawToWallet?.value,
          amount: data.amount,
        },
      },
      {
        onSuccess: () => {
          trackSuccess(isRemoveAllocation ? 'removeAllocation' : 'withdraw', {
            currency: data.currency,
            amount: data.amount,
          })
          toast({
            variant: 'success',
            header: t(
              isRemoveAllocation
                ? 'rewards.removeAllocation.successNotificationTitle'
                : 'rewards.withdraw.successNotificationTitle',
              {
                walletName: data.withdrawToWallet?.name,
                currency: `${data.amount} ${data.currency}`,
              }
            ),
          })
          onSuccess()
        },
        onError: (error: BaseErrorResponse) => {
          trackError(isRemoveAllocation ? 'removeAllocation' : 'withdraw', error, {
            currency: data.currency,
            amount: data.amount,
          })
          onError(error)
        },
      }
    )
  }

  return {
    onRewardsWithdraw,
    isRewardsWithdrawPending,
  }
}
